import apiFix from "../security/apiFix";

const prices = (securityTypeCode) => {
    return apiFix
        .get(`bymaMD/prices?securityTypeCode=${securityTypeCode}`)
};

const getSecurityType = () =>{
    return apiFix
        .get(`bymaMD/getSecurityType`) 
}

const fix = {
    prices,
    getSecurityType
};


export default fix;